<script setup>
import { MagnifyingGlassIcon } from "@heroicons/vue/24/solid";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  table: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: [String, null],
    required: true,
  },
});

defineEmits(["update:modelValue"]);
</script>

<template>
  <div class="flex h-[28px]">
    <input
      type="text"
      class="h-full rounded-l border border-gray-200 px-3 py-1 text-sm placeholder:text-gray-400 focus:border-gray-300 focus:outline-none focus:ring-0"
      :placeholder="t('all.placeholder.search')"
      :value="props.modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      @keyup.enter="props.table.setGlobalFilter(props.modelValue)"
    />
    <button
      @click="props.table.setGlobalFilter(props.modelValue)"
      class="flex items-center rounded-r bg-gray-200 px-3 py-1 text-left text-sm text-indigo-600 duration-150 hover:text-white hover:bg-indigo-600"
    >
      <MagnifyingGlassIcon class="h-4 w-4" />
    </button>
  </div>
</template>
